import type { PropsWithChildren, FunctionComponent } from 'react'
import { createContext, useContext } from 'react'
import { type InstacartStoreConfiguration } from '../../../__codegen__/api'

export interface SelectedStoreConfigurationContext {
  selectedStoreConfiguration: InstacartStoreConfiguration
  selectedStoreConfigurations: InstacartStoreConfiguration[]
}

const DEFAULT_VAL: SelectedStoreConfigurationContext = {
  selectedStoreConfiguration: null,
  selectedStoreConfigurations: null,
}

const StoreConfigContext = createContext(DEFAULT_VAL)

export const SelectedStoreConfigurationProvider: FunctionComponent<
  PropsWithChildren<PropsWithChildren<SelectedStoreConfigurationContext>>
> = props => (
  <StoreConfigContext.Provider value={{ ...props }}>{props.children}</StoreConfigContext.Provider>
)

export const useSelectedStoreConfiguration = () => useContext(StoreConfigContext)
